.illustration {
  display: inline-block;
  width: var(--size);
  height: var(--size);
}

.small {
  --size: 56px;
}

.medium {
  --size: 150px;
}

.large {
  --size: 300px;
}

.intrinsic {
  --size: auto;
}
